import { ProjectRouteDeletedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import getAppEnv from '../../utils/getAppEnv';
import { routeDeletedNotification } from '../../../../notifications/routes/oldRouteNotifications';

export default ({ store, ...payload }: ProjectRouteDeletedDtoModelType) => () => {
  const route = store.routeDtos.get(String(payload.routeId));

  if (route != null) {
    if (route.uuid) {
      store.routeCalendarSummaryDtos.delete(route.uuid);
    }

    store.remove(route);

    getAppEnv(store).notification(routeDeletedNotification(payload.routeId, payload.name));

    const rootStore = getAppRoot(store);
    rootStore.model.refreshCalendarRoutes();
  }
};
